import { createApi } from "@reduxjs/toolkit/query/react";

import { ENV_CONFIG } from "../../config/global.config";
import { EMPLOYEE_API_TAGS } from "../app.constants";
import { baseQueryWithReauth } from "./baseQuery";

// --- API ---

export const employeeServiceApi = createApi({
  reducerPath: "employeeServiceApi",
  baseQuery: baseQueryWithReauth(ENV_CONFIG.EMPLOYEE_API_URL),

  tagTypes: Object.values(EMPLOYEE_API_TAGS),
  keepUnusedDataFor: 10,
  endpoints: () => ({}),
});
